export const LOAD_USERS = 'LOAD_USERS';
export const LOAD_LEVELS = 'LOAD_LEVELS';
export const LOAD_USER_BY_ID = 'LOAD_USER_BY_ID';
export const UPDATE_USER_PHOTO_THUMB = 'UPDATE_USER_PHOTO_THUMB';
export const LOAD_USER_BY_ID_FOR_PROFILE = 'LOAD_USER_BY_ID_FOR_PROFILE';
export const ADD_USER = 'ADD_USER';
export const ADD_USER_WITH_SHOP = 'ADD_USER_WITH_SHOP';
export const UPDATE_USER_BY_ID = 'UPDATE_USER_BY_ID';
export const REMOVE_USER_BY_ID = 'REMOVE_USER_BY_ID';
export const UNSET_CURRENT_USER = 'UNSET_CURRENT_USER';
export const LOAD_USERS_FAILED = 'LOAD_USERS_FAILED';
export const ADD_USER_FAILED = 'ADD_USER_FAILED';
export const REMOVE_ADD_USER_FAILED = 'REMOVE_ADD_USER_FAILED';
export const UPDATE_PERMISSIONS = 'UPDATE_PERMISSIONS';

export function loadUsers(data) {
  return {
    type: LOAD_USERS,
    payload: data,
  }
}

export function addUserFailed() {
  return {
    type: ADD_USER_FAILED,
    payload: {
      error: {
        addNewUser: false
      }
    },
  }
}

export function removeAddUserFailed() {
  return {
    type: REMOVE_ADD_USER_FAILED,
    payload:{
      error: {}
    },
  }
}

export function loadLevels(data) {
  return {
    type: LOAD_LEVELS,
    payload: data,
  }
}

export function loadUserById(data) {
  return {
    type: LOAD_USER_BY_ID,
    payload: data,
  }
}

export function updateUserPhotoThumb(data) {
  return {
    type: UPDATE_USER_PHOTO_THUMB,
    payload: data,
  }
}

export function loadUserByIdForProfile(data) {
  return {
    type: LOAD_USER_BY_ID_FOR_PROFILE,
    payload: data,
  }
}

export function addUser(data) {
  return {
    type: ADD_USER,
    payload: data,
  }
}

export function addUserWithShop(data) {
  return {
    type: ADD_USER_WITH_SHOP,
    payload: data,
  }
}

export function updateUserById(data) {
  return {
    type: UPDATE_USER_BY_ID,
    payload: data,
  }
}

export function removeUserById(data) {
  return {
    type: REMOVE_USER_BY_ID,
    payload: data,
  }
}


export function loadUsersFailed(data) {
  return {
    type: LOAD_USERS_FAILED,
    payload: data,
  }
}

export function unsetCurrentUser() {
  return {
    type: UNSET_CURRENT_USER,
    payload: {
      userProfile: null
    },
  }
}

export function updatePermissions({permission, roleId}) {
  return {
    type: UPDATE_PERMISSIONS,
    payload: {
      permission,
      roleId
    }
  }
}


// WEBPACK FOOTER //
// ./src/actions/users/index.js